import React from "react";
import { Reveal, Overline } from "./Reveal";

const Node = ({ label, sub, primary, gold }) => (
  <div
    className={`px-6 py-4 border text-center min-w-[150px] transition-colors ${
      primary
        ? "bg-gold text-navy border-gold"
        : gold
        ? "border-gold/40 text-ivory bg-navy/60 hover:border-gold"
        : "border-white/15 text-ivory/80 bg-midnight/60"
    }`}
  >
    <p className={`font-serif ${primary ? "text-2xl" : "text-xl"}`}>{label}</p>
    {sub && <p className={`text-[10px] uppercase tracking-[0.2em] mt-1 ${primary ? "text-navy/70" : "text-ivory/40"}`}>{sub}</p>}
  </div>
);

const Connector = () => <div className="w-px h-8 bg-gradient-to-b from-gold/60 to-white/10 mx-auto" />;

export const BrandArchitecture = () => (
  <section data-testid="brand-architecture" className="bg-navy text-ivory py-24 lg:py-32 noise-overlay">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal className="max-w-3xl mb-16">
        <Overline>Brand Architecture</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight">
          One umbrella. A structured portfolio.
        </h2>
        <p className="mt-6 text-lg text-ivory/60 leading-relaxed">
          A clear hierarchy connects the corporate parent to every brand and sub-brand across the KRV ecosystem.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="flex flex-col items-center">
        <Node label="KRV Nexus" sub="Corporate / Parent" primary />
        <Connector />

        <div className="grid md:grid-cols-2 gap-10 lg:gap-24 w-full max-w-4xl">
          {/* KRVMart branch */}
          <div className="flex flex-col items-center">
            <Node label="KRVMart" sub="Retail Ecosystem" gold />
            <Connector />
            <div className="grid grid-cols-2 gap-3">
              {["Home Mart", "Style Mart", "Wood Mart", "Tech Mart"].map((s) => (
                <Node key={s} label={s} />
              ))}
            </div>
          </div>

          {/* KRV FinMart branch */}
          <div className="flex flex-col items-center">
            <Node label="KRV FinMart" sub="Education & Research" gold />
            <Connector />
            <div className="grid grid-cols-2 gap-3">
              {["Education", "Research"].map((s) => (
                <Node key={s} label={s} />
              ))}
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
